import { Col, Form, Row } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaRangePicker } from "apps/Common/MazakaRangePicker";
import dayjs from "dayjs";
import useMazakaForm from "hooks/useMazakaForm";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetInvoiceFilter } from "../ClientSideStates";


interface DetailsFilterProps {
  onFinish: any;
}

const DetailsFilter: FC<DetailsFilterProps> = ({ onFinish }) => {
  const { filter } = useSelector((state: RootState) => state.invoice);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    const formValues = form.getFieldsValue();
    let currentFilter = { ...filter };

    for (let key in formValues) {
      if (
        !formValues[key] ||
        (Array.isArray(formValues[key]) && formValues[key].length === 0)
      ) {
        delete formValues[key];
        delete currentFilter[key];
      }
    }
    if (formValues?.Date && formValues["Date"][0] && formValues["Date"][1]) {
      formValues["StartDate"] = dayjs(formValues["Date"][0]).format(
        "YYYY-MM-DD"
      );
      formValues["EndDate"] = dayjs(formValues["Date"][1]).format("YYYY-MM-DD");
      delete formValues["Date"];
    } else {
      mazakaForm.setFailed(
        2000,
        "Tarih aralığnda Başlangıç ve bitiş tarihi zorunlu "
      );
    }
    const newFilter = { ...currentFilter, ...formValues };

    await dispatch(
      handleSetInvoiceFilter({
        filter: newFilter,
      })
    );
    mazakaForm.setSuccess(1000, () => {}, "Başarılı");
    onFinish();
  };

  useEffect(() => {
    const startDate = filter["StartDate"] ? dayjs(filter["StartDate"]) : null;
    const endDate = filter["EndDate"] ? dayjs(filter["EndDate"]) : null;
    const dateRange = startDate && endDate ? [startDate, endDate] : [];
    form.setFieldsValue({
      Date: dateRange,
    });
  }, [filter]);
  return (
    <>
      <Col span={24}>
        <MazakaForm
          form={form}
          onFinish={handleOnFinish}
          submitButtonVisible={false}
        >
          <Row gutter={[10, 10]}>
            <MazakaRangePicker
              name={"Date"}
              label="Tarih Aralığı"
              xs={24}
              className="!m-0"
              rules={[{ required: true, message: "" }]}
            />
            <Col xs={24}>
              <MazakaButton
                className="!bg-black !text-white"
                type="primary"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                Filtrele
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default DetailsFilter;
